import React from 'react';
import ReactDOM from 'react-dom';
import ClickyGame from './components/ClickyGame';
import './index.css';

ReactDOM.render(<ClickyGame />, document.getElementById('root'));

